import type { Intent } from '../types';

/** The pending intents the server hasn't seen: everything above its `lastIntentId`. */
export function unacknowledged(pending: readonly Intent[], lastIntentId: number): Intent[] {
  return pending.filter((intent) => intent.id > lastIntentId);
}

/** Drops every pending intent up to and including `intentId` (the server answers in order). */
export function dropThrough(pending: readonly Intent[], intentId: number): readonly Intent[] {
  if (!pending.some((intent) => intent.id <= intentId)) return pending;
  return pending.filter((intent) => intent.id > intentId);
}
